import styled, { css } from 'styled-components';
import { colors, media } from 'src/components/base';

import RichText from '../rich-text';
import Slice from '../slice';

import type { PrismicSliceHeroTitle } from '../../../../../types';

type HeroProps = {
  textColor: string;
} & Pick<PrismicSliceHeroTitle, 'heroImage' | 'heroBackgroundColor'>;

const heroBackground = css<Omit<HeroProps, 'textColor'>>(props => {
  const hasHeroImage = props.heroImage && props.heroImage.url;

  if (hasHeroImage)
    return css`
      background-image: ${props.heroImage && props.heroImage.Desktop?.url
        ? `url(${props.heroImage.Desktop.url})`
        : 'none'};
      background-size: cover;
      background-position: center center;
      border-left: 0;

      ${media.smallOnly`
      background-position: center right;
      background-image: ${
        props.heroImage?.Mobile?.url
          ? `url(${props.heroImage.Mobile.url})`
          : 'none'
      };
    `};
    `;

  return css`
    background-color: ${props.heroBackgroundColor ??
    colors.lightTheme.maybeBlue500};
  `;
});

export const Hero = styled(Slice)<HeroProps>(props => {
  return css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: ${props.textColor};
    border-left: 0;
    padding: 56px 32px 32px 24px;
    gap: 16px;
    ${heroBackground}
    ${media.smallOnly`
        padding: 40px 16px 24px;
    `};
  `;
});

export const TextContent = styled.div`
  max-width: 66%;

  ${media.smallOnly`
    max-width: 100%;
  `};
`;

export const Title = styled(RichText)<Pick<PrismicSliceHeroTitle, 'textAlign'>>(
  props => css`
    text-align: ${!props.textAlign ? 'left' : props.textAlign};
  `
);

export const SubTitle = styled(RichText)<
  Pick<PrismicSliceHeroTitle, 'textAlign'>
>(
  props => css`
    text-align: ${!props.textAlign ? 'left' : props.textAlign};
  `
);
